import AuthenticationForm from './AuthenticationForm';

export { type IAuthenticationFormFields } from './AuthenticationForm.types';
export default AuthenticationForm;
